var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.content)?_c('div',[_c('v-card',{staticClass:"px-0 py-4",staticStyle:{"min-height":"40px"},attrs:{"flat":""}},[(_vm.options.content)?_c('TipTapReader',{key:_vm.componentKey,staticClass:"tiptap_style",attrs:{"options":_vm.options}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }